import { Component, ViewEncapsulation, ViewChild, Renderer2, ChangeDetectorRef } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_InvoiceEquipmentBus } from '@app/cp/shared/models/v_InvoiceEquipmentBus';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { EquipmentService } from '@app/cp/shared/services/equipment.service';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { EquipCustomFieldsComponent } from '@app/cp/dispatches/equipment/equip-custom-fields/equip-custom-fields.component';
import { EquipFieldData } from '@app/cp/shared/models/EquipFieldData';

@Component({
    selector: 'invoice-equipment',
    templateUrl: './invoice-equipment.component.html',
    styleUrls: ['./invoice-equipment.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvoiceEquipmentComponent extends BaseGridEditLineComponent<v_InvoiceEquipmentBus, null, InvoiceService>
{

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, private svc_equip: EquipmentService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.disableCpSearchDialog();
        this.className = "v_InvoiceEquipmentBus";
        this.appCode = "InvoiceEquipment";

    }

    @ViewChild('equipCustomFields') protected equipCustomFields: EquipCustomFieldsComponent;
    cancelCustomFields() {
        this.ctrlOpenFlag = false;
    }
    saveCustomFields(data: EquipFieldData) {
        this.editForm.patchValue({
            equipFieldData: data,
        });
        this.ctrlOpenFlag = false;
    }
    showCustomFields() {
        this.ctrlOpenFlag = true;
        let dataObj: EquipFieldData = null;
        if (!this.selectedData.equipFieldData.hasId && this.selectedData.hasId) {
            this.svc_equip.getEquipFieldData(this.selectedData.equipmentId).subscribe(data => {
                dataObj = new EquipFieldData(data);
                this.equipCustomFields.show(dataObj, false);
            });
        }
        else {
            dataObj = new EquipFieldData(this.selectedData.equipFieldData);
            this.equipCustomFields.show(dataObj, false);
        }
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
        'invoiceEquipmentXREFId': new UntypedFormControl(),
        'invoiceId': new UntypedFormControl(),
        'equipmentId': new UntypedFormControl(),
        'manufacturerId': new UntypedFormControl(),
        'manufacturerTypeId': new UntypedFormControl(),
        'locationId': new UntypedFormControl(),
        'systemId': new UntypedFormControl(),
        'model': new UntypedFormControl(),
        'serialNumber': new UntypedFormControl(),
        'barcode': new UntypedFormControl(),
        'notes': new UntypedFormControl(),
            'creationDate': new UntypedFormControl(),
            'isPrintable': new UntypedFormControl()
    });

    }
    setForm() {
        this.editForm.patchValue({
            invoiceEquipmentXREFId: this.selectedData.invoiceEquipmentXREFId,
            invoiceId: this.selectedData.invoiceId,
            equipmentId: this.selectedData.equipmentId,
            manufacturerId: this.selectedData.manufacturerId,
            manufacturerTypeId: this.selectedData.manufacturerTypeId,
            locationId: this.selectedData.locationId,
            systemId: this.selectedData.systemId,
            model: this.selectedData.model,
            serialNumber: this.selectedData.serialNumber,
            barcode: this.selectedData.barcode,
            notes: this.selectedData.notes,
            creationDate: this.selectedData.creationDate,
            isPrintable: this.selectedData.isPrintable,
        });
    }
    setFromReferenceData(data: v_InvoiceEquipmentBus) {
        data.manufacturerName = this.referenceData.getManufacturerDesc(data.manufacturerId);
        data.manufacturerTypeName = this.referenceData.getManufacturerTypeDesc(data.manufacturerTypeId);
        return data;
    }
    getChangedObject(data: v_InvoiceEquipmentBus) {
        let busObj: v_InvoiceEquipmentBus = new v_InvoiceEquipmentBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(data: v_InvoiceEquipmentBus) {

        let busObj: v_InvoiceEquipmentBus = this.getChangedObject(data);

        this.svc_data.saveInvoiceEquipment(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let dataObj: v_InvoiceEquipmentBus = new v_InvoiceEquipmentBus(info.primaryReturn);
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(data, info.message);
            }
        });
    }
    deleteIndividual(data: v_InvoiceEquipmentBus) {
        if (data.hasId) {
            this.svc_data.deleteInvoiceEquipment(data.equipmentId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, info.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isPrintable") {
            this.editForm.patchValue({
                isPrintable: e.target.checked
            });

        }

    }
}
